// Adresse.vue

<template>
   <v-container>
      <v-row>
         <v-col cols='8'><h1>Test d'éligibilité aux offres BOX</h1></v-col>
         <v-col cols='4' class="text-right">
           <v-btn :to="goback">Retour</v-btn>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <br/>

      <v-row>
         <v-col cols='12' sm='12' md='8'>
           <p class="para">Localisez le logement à partir de la <strong>référence de l'immeuble</strong>, de l'<strong>adresse postal</strong> ou en vous <strong>localisant</strong> si vous vous trouver en ce moment près du logement à tester  
          </p>
         </v-col>
         
      </v-row>

    <v-row v-if="$root.user.type =='TLV' && sendLink" justify="center" align="center">
     
        <h2>Veuillez patienter! En attente de geolocalisation du client</h2>
   
    </v-row>
    <v-progress-linear
      v-if="showWait"
      color="deep-purple accent-4"
      indeterminate
      rounded
      height="6"
    ></v-progress-linear>  
    <p>{{ message }}</p>
    <v-row v-if="!sendLink">
      <v-col col="12">
        <div>

          <v-expansion-panels  accordion >

            <v-expansion-panel v-if="$root.user.type !='TLV'">
              <v-expansion-panel-header>Me localiser</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row justify="center">
                  <v-col cols="8" sm="5" md="5" lg="5">
                    <v-chip
                      class="ma-2"
                      color="violet"
                      text-color="white"
                      v-if="showBtGeoloc"
                      v-on:click="localiser()"
                    >
                      <strong>Me localiser</strong>
                      <v-icon right color="white">mdi-map-marker</v-icon>
                    </v-chip>
                    </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel v-if="$root.user.type =='TLV'">
              <v-expansion-panel-header>Localisation avec coordonnées X Y</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-expansion-panels accordion>
                  <v-expansion-panel >
                    <v-expansion-panel-header>Saisisser les coordonnées X Y</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row justify="center">
                        <v-col cols="8">
                          <v-text-field                     
                              label="Coordonnées X"
                            v-model="coordX"
                            hide-details="yes"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="8">
                          <v-text-field                     
                              label="Coordonnées Y"
                            v-model="coordY"
                            hide-details="yes"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="8" sm="5" md="5" lg="5">
                          <v-btn v-on:click="locationByCoordXY()"  outlined block class="rechercher">Rechercher</v-btn>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel v-if="$root.user.type =='TLV'">
                    <v-expansion-panel-header>Demander les coordonnées au client</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row justify="center">
                        <v-col cols="12">
                          <v-card class="elevation-5">
                            <v-card-title class="headline title_size">
                              Envoyer le lien de localisation au client
                            </v-card-title>
                            <v-card-text>              
                              <v-form>
                                <v-text-field
                                    label="Adresse e-mail"
                                    name="contactEmail"
                                    prepend-icon="mdi-email"
                                    type="text" 
                                    v-model="contactEmail"    
                                    clearable                
                                    :error-messages="emailErrors"
                                    @input="$v.contactEmail.$touch()"
                                    @blur="$v.contactEmail.$touch()"
                                  ></v-text-field>
                                  <v-text-field
                                    label="Téléphone mobile"
                                    name="contactNumMobile"
                                    prepend-icon="mdi-cellphone"
                                    type="number" 
                                    required
                                    v-model="contactNumMobile"  
                                    clearable
                                    :error-messages="mobileErrors"
                                    :counter="10"
                                    @input="$v.contactNumMobile.$touch()"
                                    @blur="$v.contactNumMobile.$touch()"
                                  ></v-text-field>
                                            
                              </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn @click="sendGeolocBySmsAndEmail" color="primary" :loading="loadingSendLink">Envoyer</v-btn>
                              </v-card-actions>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
               
                </v-expansion-panels>
              </v-expansion-panel-content>
            </v-expansion-panel>

            

            <v-expansion-panel>
              <v-expansion-panel-header>Référence de l'immeuble</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row justify="center">
                  <v-col cols="8" sm="8" offset="2">
                    <v-text-field                     
                        label="Référence de l'immeuble"
                      v-model="refImmeuble"
                      hide-details="yes"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="8" sm="5" md="5" lg="5">
                    <v-btn v-on:click="validRefImmeuble()" :loading="loading2" outlined block class="rechercher">Rechercher</v-btn>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header>Adresse postal</v-expansion-panel-header>
              <v-expansion-panel-content>
                  <v-row align="center">
                    <v-col cols="8" sm="8" offset="2">


                      <div v-if="errorStr">Localisation impossible. Veuillez saisir une adresse</div>
                      <div v-if="gettingLocation">
                        <i>Obtention de votre localisation...</i>
                      </div>

                      <div
                        v-if="location"
                      >Your location data is {{ location.coords.latitude }}, {{ location.coords.longitude}}</div>
                    </v-col>
                  </v-row>
                  <br />
                  <br />
                  <v-row justify="center">
                    <v-col cols="10" sm="8" md="8" lg="8">
                      <v-select
                        label="Ville"
                        outlined
                        :items="lstCommunes"
                        item-text="nom_commune"
                        item-value="code_commune"
                        v-on:change="selCommune()"
                        v-model="code_commune"
                      ></v-select>
                    </v-col>
                    <v-col cols="10" sm="8" md="8" lg="8">
                      <v-autocomplete
                        outlined
                        :disabled="!code_commune"
                        label="Voie"
                        v-model="voie"
                        :items="lstVoies"
                        :search-input.sync="reqVoie"
                        item-text="nom_voie"
                        clearable
                        return-object
                        v-on:change="selVoie()"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="10" sm="8" md="8" lg="8">
                      <v-autocomplete
                        outlined
                        :disabled="!voie"
                        label="N° de voie"
                        v-model="numvoie"
                        :items="lstNumVoies"
                        :search-input.sync="reqNumVoie"
                        item-text="num_voie"
                        clearable
                        return-object
                        v-on:change="selNumVoie()"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="8" sm="5" md="5" lg="5">
                      <v-btn v-on:click="validAdresse()" outlined block class="rechercher">Rechercher</v-btn>
                    </v-col>
                  </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-col>
    </v-row>
   
  </v-container>
</template>
<script>
import { EligibiliteService } from "../../../../../providers/EligibiliteService";
const eligibiliteService = new EligibiliteService();


import {SouscriptionService} from '../../../../../providers/SouscriptionService.js';
const souscriptionService = new SouscriptionService();

import {AppService} from '../../../../../providers/AppService.js';
const appService = new AppService();

import { minLength,maxLength,email } from 'vuelidate/lib/validators'
let msgServer;
export default {
  data() {
    return {
      goback: null,
      latitude: 14.60302,
      longitude: -61.044534,
      showBtGeoloc: false,
      coordonate: "",
      location: null,
      gettingLocation: false,
      errorStr: null,
      loading2:false,
      lstCommunes: [],
      lstVoies: [],
      lstNumVoies: [],
      code_commune: null,
      voie: null,
      numvoie: null,
      reqVoie: null,
      reqNumVoie: null,
      debounce: null,
      refImmeuble : null,
      coordX: null,
      coordY: null,       
      sendLink: false,      
      loadingSendLink : false,      
      contactEmail:null,
      contactNumMobile:null,
      showWait: false,
      message:''
    };
  },
  validations: {
    contactNumMobile: { minLength: minLength(10),maxLength: maxLength(10) },    
    contactEmail: { email }
  },
  computed: {
    mobileErrors () {
      const errors = []
      if (!this.$v.contactNumMobile.$dirty) return errors
      !this.$v.contactNumMobile.maxLength && errors.push('Numero à 10 chiffres')
      !this.$v.contactNumMobile.minLength && errors.push('Numero à 10 chiffres')
      return errors
    },
    emailErrors () {
      const errors = []
      //this.errorEmail="";
      if (!this.$v.contactEmail.$dirty) return errors
      !this.$v.contactEmail.email && errors.push('Adresse email invalide')
      //if(this.errorEmail != '') errors.push(this.errorEmail)
      return errors
    }
  },
  async created() {
     
  },
  mounted() {
    if(this.$root.user.type == 'PRO') {
      this.goback = this.$root.menu.homePage;
    } else {
      this.goback = "/souscription/choixcategorieoffre";
    }

    this.$root.initSouscription();
    this.queryCommunes();

    if (this.$root.user.type != "COM") this.showBtGeoloc = true;
    else if (!("geolocation" in navigator)) {
      this.showBtGeoloc = false;
      return;
    }
  },
  watch: {    
    reqVoie(val) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        //this.typing = null
        //this.message = event.target.value
        this.queryVoies(val);
      }, 500);
    },
    reqNumVoie(val) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        //this.typing = null
        //this.message = event.target.value
        this.queryNumVoies(val);
      }, 500);
    },
  },
  beforeDestroy() {
    // Make sure to close the connection with the events server
    // when the component is destroyed, or we'll have ghost connections!
    if(msgServer)
      msgServer.close();
  },
  methods: {
    locationByCoordXY(){
      if(!this.coordX || !this.coordY) {
          this.$dialog.warning({
            text: "Veuillez saisir les coordonnées X et Y",
            title: "Recherche par coordonnées X Y",
            persistent: true
          });
      } else {
        this.openMap(this.coordX, this.coordY);
      }
    },
    selCommune: function () {
      this.queryVoies();
    },
    selVoie: function() {
      this.queryNumVoies();
    },
    selNumVoie: function() {
      if(this.numvoie) {
        this.latitude = this.numvoie.lat;
        this.longitude = this.numvoie.lon;
      }

    },
    queryCommunes: function() {
      eligibiliteService
      .getListeCommunes(this.$root.user.site)
      .then((res) => {
        if (res) {
          if (res.err != "error" && res.params) {
            this.lstCommunes = res.params;
          }
        }
      })
      .catch((error) => {
        this.loading = false;
        this.$dialog.notify.error(this.$root.errorMessage, {
          position: "bottom-right",
          timeout: 5000,
        });
        return error;
      });
    },
    queryVoies: function (sr) {
      this.loading = true;
      const selcomm = this.code_commune.split('|');
      const code_post = selcomm[0];
      const lib_commune = selcomm[1];
      eligibiliteService
        .getListeVoies(code_post, lib_commune, sr)
        .then((res) => {
          if (res) {
            if (res.err != "error" && res.params) {
              this.lstVoies = res.params;
            }
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$dialog.notify.error(this.$root.errorMessage, {
            position: "bottom-right",
            timeout: 5000,
          });
          return error;
        });
    },
    queryNumVoies: function (sr) {
      this.loading = true;
      const selcomm = this.code_commune.split('|');
      const code_post = selcomm[0];
      const lib_commune = selcomm[1];
      eligibiliteService
        .getListeNumVoies(code_post, lib_commune, this.voie.nom_voie, sr)
        .then((res) => {
          if (res) {
            if (res.err != "error" && res.params) {
              this.lstNumVoies = res.params;
            }
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$dialog.notify.error(this.$root.errorMessage, {
            position: "bottom-right",
            timeout: 5000,
          });
          return error;
        });
    },
    
    localiser: function () {
      

      var geo_options = {
        timeout: 10000,
        //maximumAge: 60000,
        enableHighAccuracy: true,
      };
      this.location = null;

      this.gettingLocation = true;
      this.errorStr = "";
      // get position
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          this.gettingLocation = false;
          this.location = pos;
          if (pos && pos.coords && pos.coords.latitude)
            this.openMap(pos.coords.latitude, pos.coords.longitude);
          else {
            this.$dialog.warning({
              text: "La tentative de localisation a échoué.<br>Veuillez réessayer ou utiliser la recherche à partir de l'adresse postale",
              title: "Echec de localisation",
              persistent: true,
            });
          }
        },
        (err) => {
          this.gettingLocation = false;
          this.errorStr = err.message;
          this.$dialog.warning({
            text: "La tentative de localisation a échoué.<br>Veuillez réessayer ou utiliser la recherche à partir de l'adresse postale",
            title: "Echec de localisation",
            persistent: true,
          });
        },
        geo_options
      );
    },
    validAdresse: function () {
        if(!this.voie) {
            this.$dialog.warning({
              text: "Veuillez sélectionner un nom de voie",
              title: "Recherche par adresse",
              persistent: true
            });
        } else {
          if(!this.numvoie) {
            const selcomm = this.code_commune.split('|');
            const code_post = selcomm[0];
            const lib_commune = selcomm[1];

            eligibiliteService
              .getCoordVoie(code_post, lib_commune, this.voie.nom_voie)
              .then((res) => {
                if (res) {
                  if (res.err != "error" && res.params) {
                    this.latitude = res.params[0].lat;
                    this.longitude = res.params[0].lon;

                    this.openMap(this.latitude, this.longitude);
                  }
                }
              })
              .catch((error) => {
                this.loading = false;
                this.$dialog.notify.error(this.$root.errorMessage, {
                  position: "bottom-right",
                  timeout: 5000,
                });
                return error;
              });
          } else {
            this.openMap(this.latitude, this.longitude);
          }

        }
        
    },validRefImmeuble: function () {
        if(!this.refImmeuble) {
            this.$dialog.warning({
              text: "Veuillez saisir la référence de l'immeuble",
              title: "Recherche par Référence d'immeuble",
              persistent: true
            });
        } else {
          this.loading2 = true;
          eligibiliteService
            .getEligibiliteByIdImmeuble(this.refImmeuble,this.$root.user.domaine,this.$root.user.site)
            .then((res) => {
              this.loading2 = false;
              if (res) {
                if ( res.err !='error' && res.params.eligibilite) {
                  
                const lat = res.params.eligibilite.adresse.x;
                const lon = res.params.eligibilite.adresse.y;
                res.params.eligibilite.lat = lat;
                res.params.eligibilite.lon = lon;
                res.params.eligibilite.gotBy = 'refImmeuble';
                this.$globalService.setUser(res.params.user);
                const sessionSouscription = this.$globalService.setSessionSouscription('eligibilite',res.params.eligibilite);
                if(sessionSouscription == null || !sessionSouscription.eligibilite){
                  this.$dialog.error({
                    text: "Une erreur s'est produite",
                    title: 'Erreur',
                    persistent: false,
                    actions: {
                      false: 'Fermer'
                    }
                  })
                }


                  this.openMap(lat, lon);
                }else{
                  this.$dialog.error({
                    text: "Erreur lors de la vérification de l'éligibilité pour cette référence d'immeuble",
                    title: "Erreur d'eligibilite",
                    persistent: false,
                    actions: {
                      false: 'Fermer'
                    }
                  })
                }
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$dialog.notify.error(this.$root.errorMessage, {
                position: "bottom-right",
                timeout: 5000,
              });
              return error;
            });
          

        }
        
    },
    openMap: function (lat, lon) {
      this.$router.push({
        path: "/souscription/offresbox/eligibilite/carto",
        query: { lat: lat, lon: lon },
      });
    },
    
    sendGeolocBySmsAndEmail: function(){
      if(!this.contactNumMobile && !this.contactEmail) {
            this.$dialog.warning({
              text: "Veuillez saisir le N° de mobile ou l'adresse email",
              title: "Demande de localisaton",
              persistent: true
            });
      } else {
        this.loadingSendLink = true;
        souscriptionService.sendGeolocBySmsAndEmail(this.$root.user.codevendeur,this.contactEmail, this.contactNumMobile).then(res => {
            this.loadingSendLink = false;
            if (res) {
              if (res.err != "error") {
                this.sendLink = true;
                this.showWait = true;
                
                this.$dialog.notify.warning(res.err_msg, {
                  position: "bottom-right",
                  timeout: 5000,
                });
                this.serverSentEvent(res.params.uuid);
              }else{
                //this.dialogAriad = false;
                this.$dialog.error({
                  text: res.err_msg,
                  title: 'Erreur',
                  persistent: false,
                  actions: {
                    false: 'Fermer'
                  }
                })
              
              }
            }
          })
          .catch((error) => {
            this.loadingSendLink = false;
            //this.dialogAriad = false;
            this.$dialog.notify.error(this.$root.errorMessage, {
              position: "bottom-right",
              timeout: 5000,
            });
            return error;
          });
      }
    },
    
    serverSentEvent: function(uuid){
      //récuperation dans la session
      if(uuid != null){      
      

            //***************************** PARTIE SSE */
            this.$sse(appService.getBaseUrl()+'/sse/sse_geoloc.php?uuid='+uuid, { format: 'json' })
              .then(sse => {
                // Store SSE object at a higher scope
                msgServer = sse;
        
                //si statut progress ne fais rien 
                sse.subscribe('PROGRESS', () => {
                  this.message = 'TRAITEMENT EN COURS !!!';
                  

                });

                //si statut progress ne fais rien 
                sse.subscribe('FINISH', (params) => {
                  this.message = "ANALYSE DE LE GEOLOCALISATION !!!";
                  msgServer.close();
                    if(params && params.lat && params.lon){
                      this.openMap(params.lat,params.lon)
                    }else{
                        this.$dialog.error({
                          text: "Analyse impossible suite à une erreur technique",
                          title: 'Erreur',
                          persistent: false,
                          actions: {
                            false: 'Fermer'
                          }
                        })
                      
                      }

                });

                sse.subscribe('ERROR', () => {
                  this.showWait = false;
                  this.$dialog.error({
                    text: this.$root.errorMessage,
                    title: 'Erreur',
                    persistent: false,
                    actions: {
                      false: 'Fermer'
                    }
                  })
                  msgServer.close();
                });
            })
          .catch(err => {
            
              console.error('Failed to connect to server', err);
              this.$dialog.error({
                text: this.$root.errorMessage,
                title: 'Erreur',
                persistent: false,
                actions: {
                  false: 'Fermer'
                }
              })
          });

        //******************* FIN SSE */
      }else{
        this.$dialog.error({
          text: this.$root.errorMessage,
          title: 'Erreur',
          persistent: false,
          actions: {
            false: 'Fermer'
          }
        })
      }
      
    }
  }
};
</script>

<style>
   .rechercher {
      background-image: linear-gradient(to right,var(--v-violet-base) 0,var(--v-rubine-base) 100%);
      color:white !important;
   }
</style>